import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UredjajiService {
  constructor(private _http: HttpClient) {}

  dohvatiSveUredaje(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'uredjajPopis', a)
      .pipe(map((res: any) => res));
  }

  urediUredjaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'uredjajUredi', a)
      .pipe(map((res: any) => res));
  }


}
